import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 900px;
  z-index: 2;
`;

type ImageProps = {
  $img: string;
};

export const InnerContainer = styled.div<ImageProps>`
  margin: 0 auto;
  width: 70%;
  height: 550px;
  width: 1300px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  @media (max-width: 430px) {
    width: 100%;
    border-radius: 0;
  }
`;
export const InnerContainer2 = styled.div<ImageProps>`
  margin: 0 auto;
  width: 70%;
  height: 550px;
  width: 1300px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  @media (max-width: 430px) {
    width: 393px;
    border-radius: 0;
  }
`;

export const H11 = styled.div`
  font-family: Cormorant Infant;
  font-size: 120px;
  font-weight: 500;
  text-align: center;
  color: #55749f;
  @media (max-width: 430px) {
    font-size: 50px;
  }
`;
export const Smth = styled.div`
  display: none;
`;

export const X2 = styled.div<ImageProps>`
  cursor: pointer;
  display: block;
  font-size: 20px;
  margin-left: auto;
  width: 21px;
  height: 21px;
  margin-top: 10px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  background-position: center;
  -webkit-transition-duration: 0.8s;
  -moz-transition-duration: 0.8s;
  -o-transition-duration: 0.8s;
  transition-duration: 0.8s;

  -webkit-transition-property: -webkit-transform;
  -moz-transition-property: -moz-transform;
  -o-transition-property: -o-transform;
  transition-property: transform;

  overflow: hidden;
  &:active {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }
`;

export const H1 = styled.div`
  font-family: Cormorant Infant;
  font-size: 120px;
  font-weight: 500;
  text-align: center;
  color: #141414;
  @media (max-width: 430px) {
    font-size: 50px;
  }
`;
export const X = styled.div<ImageProps>`
  position: absolute;
  z-index: 5000;
  cursor: pointer;
  display: block;
  display: none;
  font-size: 20px;
  top: 70px;
  width: 21px;
  height: 21px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: 430px) {
    margin-left: 350px;
  }
`;

export const H2 = styled.div`
  margin-top: 60px;
  margin-bottom: 60px;
  font-family: Avenir Next;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  @media (max-width: 430px) {
    font-size: 18px;
  }
`;

export const SmallText = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 22px;
  padding-top: 40px;
  width: 140px;
  color: #ffffff;
`;

export const SmallText2 = styled.div`
  padding: 0;
  margin: 0;
  display: block;
  margin: 0 auto;
  align-items: center;
  font-size: 22px;
  padding-top: 40px;
  width: 140px;
  color: #000000;
  text-align: center;
`;
export const Text2 = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 70px;
  font-family: Cormorant Infant;
  font-weight: 500;
  text-align: center;
  color: #000000;
  @media (max-width: 430px) {
    font-size: 50px;
  }
`;

export const Btn = styled.a`
  display: block;
  margin: 0 auto;
  margin-top: 36px;
  padding: 5px 10px;
  width: 150px;
  background-color: white;
  color: black;
  border: 1px solid white;
  cursor: pointer;
  border-radius: 30px;
  text-align: center;
  font-size: 20px;
  font-family: Avenir Next;
  text-decoration: none;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;

export const AnimationTextContainer = styled.div`
  display: flex;
  margin: 0 auto;
  margin-bottom: 55px;
  margin-top: 36px;
  width: 400px;
  height: 55px;
  background-color: #ffffff;
  border: 1px solid black;
  border-radius: 30px;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  padding-left: 10px;
  @media (max-width: 430px) {
    width: 380px;
    border-radius: 20px;
    padding: 5px;
    height: 40px;
  }
`;

export const AnimatedFrame1 = styled.button`
  display: block;
  padding: 4px 8px;
  border-radius: 20px;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  border: none;
  background-color: #bfdcf5;
  cursor: pointer;
  @media (max-width: 430px) {
    padding: 2px 5px;
    border-radius: 20px;
  }
`;
export const AnimatedFrame2 = styled.button`
  display: block;
  padding: 5px 10px;
  border-radius: 20px;
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  border: none;
  background-color: #ffffff;
  cursor: pointer;
  @media (max-width: 430px) {
    padding: 2px 5px;
    border-radius: 20px;
  }
`;

export const Block1 = styled.div`
  display: flex;
  margin-left: 10px;
  justify-content: center;
  @media (max-width: 430px) {
    overflow-x: auto;
    justify-content: start;
  }
`;
export const Block2 = styled.div`
  display: none;
  margin-left: 10px;
  justify-content: center;
  @media (max-width: 430px) {
    overflow-x: auto;
    justify-content: start;
  }
`;

export const Block1Container = styled.div`
  display: flex;
  justify-content: start;
  gap: 10px;
  height: 750px;
`;

export const Item = styled.div<ImageProps>`
  display: block;
  width: 320px;
  height: 682px;
  margin-top: 20px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;

export const Item2 = styled.div<ImageProps>`
  display: block;
  height: 682px;
  width: 320px;
  margin-top: 20px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;

export const ItemContainer1 = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  margin-left: 20px;
  height: 150px;
`;

export const ItemContainer2 = styled.div`
  display: block;
  padding-right: 20px;
  padding-left: 20px;
  height: 225px;
  margin-bottom: 20px;
`;

export const ItemContainer3 = styled.div`
  display: block;
  height: 275px;
`;

export const Circle2 = styled.div`
  background-color: #c7e8e8;
  height: 10px;
  width: 10px;
  border-radius: 8px;
`;
export const Circle = styled.div`
  background-color: #bcd3ff;
  height: 10px;
  width: 10px;
  border-radius: 8px;
`;

export const Circleq = styled.div`
  background-color: #c7e8e8;
  height: 10px;
  width: 10px;
  border-radius: 8px;
`;
export const CircleText = styled.div`
  color: black;
  display: inline;
  font-family: Avenir Next;
  font-size: 12px;
  font-weight: 300;
  text-align: left;
  text-transform: uppercase;
  padding-left: 5px;
`;
export const ItemText = styled.div`
  font-family: Cormorant Infant;
  font-size: 23px;
  width: 250px;
  font-weight: 400;
  text-align: left;
`;
export const CircleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const Meeting = styled.div`
  margin-left: 20px;
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
`;
export const Price = styled.div`
  margin-top: 10px;
  margin-left: 20px;
  font-family: Cormorant Infant;
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  margin-bottom: 30px;
`;
export const BtnText = styled.div``;
export const Btn2 = styled.a`
  margin-left: 10px;
  margin-top: 185px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  width: 265px;
  height: 40px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  text-decoration: none;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;

export const Btn2Custom = styled.a`
  margin-left: 20px;
  margin-top: 185px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  width: 265px;
  height: 50px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  text-decoration: none;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;

export const BtnImg = styled.div<ImageProps>`
  display: block;
  width: 25px;
  height: 15px;
  margin-top: 4px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
  align-items: center;
`;

export const Btn1 = styled.button`
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px 10px;
  width: 265px;
  height: 50px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;

export const Mission = styled.div`
  margin: 0 auto;
  width: 70px;
  font-family: Avenir Next;
  font-size: 22px;
  font-weight: 400;
  text-align: left;
`;
export const SmallText3 = styled.div`
  margin-top: 36px;
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: center;
  @media (max-width: 430px) {
    font-size: 20px;
    width: 390px;
    padding: 10px;
    align-items: center;
  }
`;
export const H112 = styled.div`
  font-family: Cormorant Infant;
  font-size: 60px;
  font-weight: 500;
  text-align: center;
  color: #141414;
  @media (max-width: 430px) {
    font-size: 40px;
  }
`;

export const H12 = styled.div`
  display: inline;
  font-family: Cormorant Infant;
  font-size: 60px;
  font-weight: 500;
  text-align: center;
  color: #55749f;
  margin-left: 20px;
  @media (max-width: 430px) {
    font-size: 40px;
  }
`;

export const Btn3 = styled.button`
  display: block;
  margin: 0 auto;
  margin-top: 36px;
  margin-bottom: 80px;
  padding: 5px 10px;
  width: 150px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
  @media (max-width: 430px) {
    width: 370px;
  }
`;
export const Btn4 = styled.a`
  display: block;
  margin: 0 auto;
  margin-top: 36px;
  margin-bottom: 80px;
  padding: 5px 10px;
  width: 250px;
  background-color: white;
  color: black;
  border: 1px solid white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  text-decoration: none;
  align-items: center;
  text-align: center;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;

export const SmallText4 = styled.div`
  width: 80px;
  padding-top: 20px;
  font-family: Avenir Next;
  font-size: 22px;
  font-weight: 400;
  text-align: left;
  color: white;
  margin: 0 auto;
`;
export const Text3 = styled.div`
  font-family: Cormorant Infant;
  font-size: 60px;
  font-weight: 300;
  text-align: center;
  color: white;
  padding-bottom: 20px;
  @media (max-width: 430px) {
    font-size: 35px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const ImgText = styled.img`
  margin: 0 auto;
  display: block;
  width: 1080px;
  height: 40px;
  margin-top: 5px;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const ImgText2 = styled.img`
  margin: 0 auto;
  display: none;
  width: 400px;
  height: 130px;
  margin-top: 5px;
  @media (max-width: 430px) {
    display: block;
  }
`;

export const Btn5 = styled.button`
  display: block;
  margin: 0 auto;
  margin-bottom: 50px;
  padding: 10px 30px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  font-weight: 500;
  align-items: center;

  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }

  @media (max-width: 430px) {
    margin-bottom: 10px;
    width: 370px;
  }
`;

export const ScrollContainer2 = styled.div`
  overflow-x: auto;
  display: flex;
  justify-content: center;
  @media (max-width: 430px) {
    margin-left: 10px;
  }
`;
export const Span = styled.div`
  font-family: Avenir Next;
  font-size: 18px;
  font-weight: 400;
  text-align: left;
  margin-right: 5px;
  color: #a7a7a7;
`;

export const Text = styled.div`
  display: block;
  margin: 0 auto;
  font-size: 70px;
  font-family: Cormorant Infant;
  font-weight: 500;
  text-align: center;
  color: #ffffff;
  transform: translateX(-80px);
  margin-right: 20px;
`;

export const Title2 = styled.div`
  display: block;
  margin: 0 auto;
  width: 1100px;
  font-family: Cormorant Infant;
  @media (max-width: 430px) {
    width: 420px;
    font-size: 25px;
    margin-left: 70px;
  }
`;
export const Title = styled.div`
  display: block;
  margin: 0 auto;
  width: 1100px;
  font-family: Cormorant Infant;
  @media (max-width: 430px) {
    width: 550px;
    font-size: 30px;
  }
`;
export const MainText = styled.div`
  display: block;
  margin: 0 auto;
  min-width: 1000px;
  height: 70px;
  font-family: Cormorant Infant;
  @media (max-width: 430px) {
    min-width: 400px;
    font-size: 25px;
    margin-left: 90px;
  }
`;

export const Mobilecont = styled.div`
  display: none;
  @media (max-width: 430px) {
    display: block;
  }
`;
export const AnimatedSection = styled.div`
  margin-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  margin-top: 50px;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const Div1 = styled.div`
  height: 544px;
  width: 1305px;
  display: flex;
  flex-direction: row;
  justify-content: start;
`;
export const PCdiv = styled.div`
  display: flex;
  height: 544px;
  width: 1305px;
  flex-direction: row;
  justify-content: start;
  @media (max-width: 430px) {
    display: none;
  }
`;
export const Mobilediv = styled.div`
  display: none;
  width: 393px;
  flex-direction: column;
  justify-content: start;
  @media (max-width: 430px) {
    display: flex;
  }
`;

export const ImgDiv = styled.div`
  width: 700px;
  height: 534px;
`;
export const TextDiv = styled.div`
  width: 700px;
  margin-left: 20px;
  height: 544px;
  border-left: 2px solid #b4b4b4;
  @media (max-width: 430px) {
    border: none;
    margin: 0;
    margin-left: 10px;
    height: auto;
    margin-bottom: 20px;
  }
`;

export const Img = styled.img`
  width: 648px;
  height: 524px;
  border-radius: 20px;
  @media (max-width: 430px) {
    width: 380px;
    height: 360px;
    border-radius: 10px;
    margin-left: 7px;
  }
`;

export const Circle1 = styled.div`
  background-color: #55749f;
  height: 10px;
  width: 10px;
  border-radius: 8px;
`;

export const CircleText1 = styled.div`
  color: black;
  display: inline;
  font-family: Avenir Next;
  font-size: 22px;
  font-weight: 400;
  text-align: left;

  letter-spacing: -0.04em;
  @media (max-width: 430px) {
    font-size: 20px;
    margin: 0;
  }
`;
export const Cont = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`;

export const TextBlack = styled.div`
  font-family: Cormorant Infant;
  font-size: 35px;
  font-weight: 500;
  text-align: left;
  @media (max-width: 430px) {
    font-size: 25px;
    margin: 0;
  }
`;

export const TextBlue = styled.div`
  font-family: Cormorant Infant;
  font-size: 35px;
  font-weight: 500;
  text-align: left;
  color: #55749f;
`;

export const TextCont = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  @media (max-width: 430px) {
    margin-left: 30px;
  }
`;

export const Div = styled.div`
  display: none;
`;
export const TextDiv1 = styled.div`
  height: 90px;
  margin-left: 40px;
  margin-top: 30px;
  @media (max-width: 430px) {
    width: 375px;
    margin-left: 0;
    display: flex;
    height: 50px;
    align-items: center;
    margin-bottom: 20px;
    justify-content: start;
    margin-left: 5px;
  }
`;
export const TextDiv2 = styled.div`
  height: 140px;
  margin-left: 40px;
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
  @media (max-width: 430px) {
    font-size: 20px;
    margin: 0;
    height: auto;
    margin-bottom: 30px;
    width: 393px;
  }
`;
export const Tag = styled.div`
  position: relative;
  margin-left: 20px;
  top: 10px;
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  width: 260px;
  padding: 5px 0px;
  border-radius: 20px;
  background-color: #bfdcf5;
`;
export const TextDiv3 = styled.div`
  height: 60px;
  margin-left: 40px;
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 500;
  text-align: left;
  margin-top: 25px;
  @media (max-width: 430px) {
    font-size: 20px;
    margin: 0;
    height: 40px;
  }
`;
export const TextDiv4 = styled.ul`
  height: 80px;
  list-style-type: "✔";
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
  margin-left: 60px;
  @media (max-width: 430px) {
    font-size: 20px;
    margin-left: 20px;
  }
`;
export const TextDiv4Li = styled.li`
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
  color: #679d00;
  @media (max-width: 430px) {
    font-size: 20px;
    margin: 0;
    height: 20px;
    margin-top: 7px;
  }
`;
export const TextDiv4Li2 = styled.div`
  color: black;
`;
